import React from 'react'
import './style.scss'

const RightSidebar = ({ navigationBtns, titles }) => {
  const toc = titles.map((title) => {
    return (
      <li key={title.id}>
        <a className={title.className} href={`#${title.outerText}`}>
          {title.outerText}
        </a>
      </li>
    )
  })

  return (
    <div className='rightSidebar'>
      <div className='rightSidebar__slicky scrollbar'>
        {navigationBtns ? <SideBtns navigationBtns={navigationBtns} /> :
          <div className='rightSidebar__btn'>
            <span style={{ marginTop: "20px" }}> </span>
          </div>
        }
        <p className='rightSidebar__title'>On this page</p>
        <div className='rightSidebar__tableOfContents'>
          <ul>{toc}</ul>
        </div>
      </div>
    </div>
  )
}
export default RightSidebar

const SideBtns = ({ navigationBtns }) => (
  <div className='rightSidebar__btn'>
    {navigationBtns[2] && (
      <a href={navigationBtns[2].href} className='rightSidebar__btn-up' > </a>
    )}
    {navigationBtns[0] && (
      <a href={navigationBtns[0].href} className='rightSidebar__btn-prev' > </a>
    )}
    {navigationBtns[1] && (
      <a href={navigationBtns[1].href} className='rightSidebar__btn-next' > </a>
    )}
  </div>
)
